import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./WebTest.css"
import {retrieveData, sendRequest, storeData, validateEmail, validatePhone} from "../../common";

function WebTestStart() {
	const navigate = useNavigate()

	const [user, setUser] = useState()
	const [applyTest, setApplyTest] = useState()
	const [test, setTest] = useState()
	const [code1, setCode1] = useState('')
	const [code2, setCode2] = useState('')
	const [code3, setCode3] = useState('')
	const [code4, setCode4] = useState('')
	const [name, setName] = useState('')
	const [phone, setPhone] = useState('')
	const [email, setEmail] = useState('')
	const [birth, setBirth] = useState('')
	const [gender, setGender] = useState('')

	const isValid = code1?.length && code2?.length && code3?.length && code4?.length && name?.length && phone?.length && email?.length && birth?.length && gender?.length

	// const getTests = () => {
	// 	sendRequest('test/test/?page=1&size=100', 'GET', null, (data, page) => {
	// 		const test_ = data?.pop()
	// 		setTest(test_)
	// 		storeData('test', test_)
	// 	})
	// }

	const getApplyTest = (e) => {
		e.preventDefault()

		if (!isValid) {
			alert('인증코드 / 이름 / 휴대폰번호 / 이메일을 다시 확인해주세요.')
			return
		}

		sendRequest(`test/apply-test/?code=${code1 + code2 + code3 + code4}&name=${name}`, 'GET', null, data => {
			if (!data?.length) {
				alert('인증 코드 및 이름을 확인해주세요.')
			} else {
				const applyTest_ = data?.pop()
				if (applyTest_?.isDone) {
					alert('이미 실시한 인증코드 입니다.')
					return
				}

				setApplyTest(applyTest_)
				setTest(applyTest_.test)
				storeData('test', applyTest_.test)
				saveApplyTest(applyTest_)
			}
		})
	}

	const saveApplyTest = (applyTest) => {
		sendRequest(`test/apply-test/${applyTest?.id}/`, 'PUT', {
			// test: test?.id,
			// code: code1 + code2 + code3 + code4,
			name,
			phone,
			email,
			birth,
			gender,
			tester: user?.id,
		}, data => {
			storeData('applyTest', data)
			navigate("/start-guide")
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
	}, [])

	return (
		<>
			<div className="webContainer">
				<section className="webTestStart">
					<h2>웹 검사 실시</h2>
					<form name="webTestStart">
						<p>인증코드 및 이름 입력</p>
						<div className="formFlex">
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">인증코드</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span className="codeWrap">
											<input type="number" pattern="[0-9]*" inputmode="numeric" min="0" max={'9999'} name="code1" maxLength={4} required value={code1} onChange={e => setCode1(e.target.value)} />
											<input type="number" pattern="[0-9]*" inputmode="numeric" min="0" max={'9999'} name="code2" maxLength={4} required value={code2} onChange={e => setCode2(e.target.value)} />
											<input type="number" pattern="[0-9]*" inputmode="numeric" min="0" max={'9999'} name="code3" maxLength={4} required value={code3} onChange={e => setCode3(e.target.value)} />
											<input type="number" pattern="[0-9]*" inputmode="numeric" min="0" max={'9999'} name="code4" maxLength={4} required value={code4} onChange={e => setCode4(e.target.value)} />
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이름</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="text" name="name" placeholder="이름을 입력해주세요" required value={name} onChange={e => setName(e.target.value)} />
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="formFlex">
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">휴대폰 번호</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="text" name="phone" placeholder="휴대폰 번호를 입력해주세요" required value={phone} onChange={e => setPhone(e.target.value)} onBlur={() => validatePhone(phone, setPhone)} maxLength={12}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이메일</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="email" placeholder="이메일을 입력해주세요" required value={email} onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="formFlex">
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">생년월일</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="text" name="birth" placeholder="19930101" required value={birth} onChange={e => setBirth(e.target.value.replace(/[^\d]/,''))} maxLength={8}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">성별</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span className="selectWrap">
											<select name="" onChange={e => {
												setGender(e.target.value)
											}}>
												<option defaultValue="">성별을 선택해주세요</option>
												<option defaultValue="">여성</option>
												<option defaultValue="">남성</option>
											</select>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="buttonWrap">
							<button
								className="submitBtn"
								onClick={getApplyTest}>
								확인
							</button>
						</div>
					</form>
				</section>
			</div>
		</>
	)
}

export default WebTestStart
